var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { key: "verify-otp", staticClass: "t-onboard__body" }, [
    _c("div", { staticClass: "t-onboard__main" }, [
      _c("div", { staticClass: "t-onboard__content" }, [
        _c("div", { staticClass: "t-onboard__logo" }, [
          _vm.partnerMode
            ? _c("img", {
                attrs: {
                  src: require(`@/lib/assets/images/partner/${_vm.partnerId}/logo.svg`),
                  height: "36px",
                },
              })
            : _c("img", {
                attrs: {
                  src: require("@/lib/assets/images/Trainn-CB-logo.svg"),
                  height: "36px",
                },
              }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "t-onboard__title" }, [
          _vm._v("\n        " + _vm._s(_vm.heading) + "\n      "),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "t-onboard__description" }, [
          _vm._v("\n        " + _vm._s(_vm.description) + "\n      "),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "t-onboard__form" },
          [
            _c(
              "div",
              { staticClass: "t-onboard__field" },
              [
                _c("t-input", {
                  attrs: {
                    talign: "center",
                    size: "large",
                    fluid: "",
                    value: _vm.email,
                    placeholder: _vm.$t("onboard.register.email_sign_up.email"),
                    readonly: true,
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "t-onboard__field mf-exclude" },
              [
                _c("t-input", {
                  attrs: {
                    fluid: "",
                    talign: "center",
                    size: "large",
                    focus: true,
                    placeholder: _vm.$t(
                      "onboard.register.email_sign_up.otp_placeholder"
                    ),
                    invalid: _vm.invalidOTP,
                  },
                  on: {
                    keyup: [
                      function ($event) {
                        _vm.invalidOTP = false
                      },
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.next()
                      },
                    ],
                  },
                  model: {
                    value: _vm.otp,
                    callback: function ($$v) {
                      _vm.otp = $$v
                    },
                    expression: "otp",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "t-button",
              {
                staticClass: "t-mar--t-sm",
                attrs: {
                  fluid: "",
                  loading: _vm.genericLoader,
                  size: "large",
                  variant: "primary",
                },
                on: {
                  click: function ($event) {
                    return _vm.next()
                  },
                },
              },
              [_vm._v("\n          " + _vm._s(_vm.cta) + "\n        ")]
            ),
            _vm._v(" "),
            _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
              _vm.resendLink
                ? _c(
                    "div",
                    {
                      staticClass: "t-mar--t-md t-onboard__caption t-ta--right",
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "onboard.register.email_sign_up.otp_undelivered"
                            )
                          )
                        ),
                      ]),
                      _c(
                        "a",
                        {
                          staticClass: "t-mar--l-ti",
                          on: {
                            click: function ($event) {
                              return _vm.resendOtp()
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "onboard.register.email_sign_up.resend_otp"
                              )
                            )
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }